import React from 'react';
import Image from '../assets/no-records.png';
import { useTranslation } from 'react-i18next';
import { IonText } from '@ionic/react';

const NoRecords: React.FC<{ width: String; smallText: Boolean }> = ({ width = '80%', smallText = false }) => {
  const { t } = useTranslation();
  return (
      <div  style={{margin: 'auto'}} className="ion-text-center">
        <img src={Image} alt={t('Utils.no_records')} width={width.toString()} />
        <IonText color="primary">
          {smallText ? <h6>{t('Utils.no_records')}</h6> : <h2>{t('Utils.no_records')}</h2>}
        </IonText>
      </div>
  );
};

export default NoRecords;
